import { createContext, useContext } from 'react'

export interface ImpersonationInfo {
  impersonating: boolean
  originalAdmin?: string
  targetUser?: string
}

export interface UserContextType {
  email: string
  name: string
  firstName?: string
  lastName?: string
  services?: string[]
  isAdmin: boolean
  impersonation?: ImpersonationInfo
}

export const UserContext = createContext<UserContextType | null>(null)

export function useUser() {
  const ctx = useContext(UserContext)
  if (!ctx) throw new Error('useUser must be used within UserProvider')
  return ctx
}
